<template>
  <v-container fluid>
    <v-card>
      <v-tabs
        v-model="tab"
        align-with-title
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="item in items"
          :key="item.tab"
        >
          {{ item.tab }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="item in items"
          :key="item.tab"
        >
          <v-card flat>
            <v-card-text>
              <component v-bind:is="item.content"></component>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import UserPage from './UserPage';
import UserHistoryPage from './UserHistoryPage';
import DisabilityCarPage from './DisabilityCarPage';
import TaxiCarPage from './TaxiCarPage';
import CustomDisabilityCarPage from './CustomDisabilityCarPage';
import CustomTaxiCarPage from './CustomTaxiCarPage';
// import Role from './Role';

export default {
  data() {
    return {
      tab: null,
      items: [
        { tab: '使用者管理', content: 'UserPage' },
        { tab: '使用者操作紀錄', content: 'UserHistoryPage' },
        { tab: '政府市外身障管理', content: 'DisabilityCarPage' },
        { tab: '自訂市外身障管理', content: 'CustomDisabilityCarPage' },
        { tab: '政府計程車管理', content: 'TaxiCarPage' },
        { tab: '自訂計程車管理', content: 'CustomTaxiCarPage' },
      ],
    };
  },
  components: {
    UserPage,
    UserHistoryPage,
    DisabilityCarPage,
    TaxiCarPage,
    CustomDisabilityCarPage,
    CustomTaxiCarPage,
    // Role,
  },
  methods: {
    
  },
};
</script>
